/* global $ , alert, parseJSON*/
import Mojito from '../../../bower_components/mojito/lib/main';

export default class MemberController extends Mojito.Controller {

    constructor(...args) {
        super(args);

        this.set('adressesBox', '.mitgliederBox');
        this.set('adresses', []);
        this.set('members', this.$().find('.mitgliederItem'));
        this.set('isLoadMore', true);
        // this.getControllerByRef('memberControllerFilter').setOption('showOnLoad');
    }

    loadMore() {
        if (this.get('isLoadMore')) {
            this.set('isLoadMore', false);
            this.getControllerByRef('memberControllerFilter').setOption('filterAll');
        } else {
            this.set('isLoadMore', true);
            this.getControllerByRef('memberControllerFilter').setOption('showOnLoad');
            $('html, body').animate({
                scrollTop: this.$().offset().top - 100
            }, 500);
        }
    }

    adressesObserver() {
        return Mojito.observer('adresses', function () {
            $(this.get('adressesBox')).html(this.get('adresses').join(', '));
        });
    }

    selectAll() {
        $('.mitglieder div[id^="member"].mitgliederItem').each(function () {
            //            let params = $(this).attr('data-params');
        });
    }

    select(params) {
        let adresses = this.get('adresses');
        let checkbox = $('#memberCeckbox' + params.id);
        let element = $('#member' + params.id);

        if (checkbox.prop('checked') === true) {
            checkbox.prop('checked', false);
            element.removeClass('is--checked');

            let index = adresses.indexOf(params.email);
            if (index > -1) {
                adresses.splice(index, 1);
            }

        } else {
            checkbox.prop('checked', true);
            element.addClass('is--checked');
            adresses.push(params.email);
        }
        this.set('adresses', adresses);
    }

    submit(event) {
        let currentData = {};

        if (!Mojito.isEmpty($(event.srcElement).serialize())) {
            currentData = this.prettifyFormData($(event.srcElement).serializeArray());
            let to = '';

            if (Array.isArray(currentData)) {
                to = currentData.memberMailAdresses.join(',');
            } else {
                to = currentData.memberMailAdresses;
            }

            let name = currentData.fname + ' ' + currentData.lname;
            this.sendMail(to, currentData.email, name, currentData.subject, currentData.text);
            // this.sendMail(to, cc, subject, text);
        }
    }

    sendMail(to, cc, name, subject, text) {
        let data = {
            to: to,
            email: cc,
            name: name,
            subject: subject,
            text: text,
            debug: true
        };


        $.ajax({
            method: 'POST',
            data: data,
            url: document.location.origin + '/sendmail/t/internal/',
            success : ( response )  => {
                switch(response) {
                    case 'true':
                        UIkit.notify({
                            message : '<i class="uk-icon-check"></i> Email wurde erfolgreich versandt!',
                            status  : 'success',
                            timeout : 5000,
                            pos     : 'bottom-center'
                        });
                        break;
                    case 'false':
                        UIkit.notify({
                            message : '<i class="uk-icon-close"></i> Email konnte nicht versandt werden bitte überprüfen Sie alle Daten!',
                            status  : 'danger',
                            timeout : 5000,
                            pos     : 'bottom-center'
                        });
                    default:
                        UIkit.notify({
                            message : 'Ein unerwartetes Problem trat auf bitte versuchen Sie es erneut!',
                            status  : 'warning',
                            timeout : 5000,
                            pos     : 'bottom-center'
                        });
                }
                console.log(response);

            },
            fail : ( response )  => {
                UIkit.notify({
                    message : '<i class="uk-icon-close"></i> Email konnte nicht versandt werden bitte überprüfen Sie alle Daten!',
                    status  : 'danger',
                    timeout : 5000,
                    pos     : 'top-center'
                });
            },
            statusCode: {
                401:function() { alert('401 Nicht Authorisiert für eine Teilnahme!'); },
                404:function() { alert('404 Event nicht gefunden'); }
            }
        });
    }

    prettifyFormData(formdata) {
        let o = {};
        let a = formdata;
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    }

    adressPutter(adress) {
        let add = this.get('adresses');
        let index = add.indexOf(adress);

        if (index > -1) {
            add.splice(index, 1);
        } else {
            add.push(adress);
        }

        this.set('adresses', add);
    }

    parsingParameter(params) {
        let attributes = [];
        if (typeof params === 'string' && params.length > 0) {

            params = params.replace(/,/g, '\',\'');
            params = params.replace(/:/g, '\':\'');
            params = params.replace(/{/g, '{\"');
            params = params.replace(/}/g, '\'}');
            params = params.replace(/\[/g, '[\'');
            params = params.replace(/\]/g, '\']');
            params = params.replace(/}"/g, '}');
            params = params.replace(/"{/g, '{');
            params = params.replace(/]"/g, ']');
            params = params.replace(/"\[/g, '[');
            if (params.charAt(0) !== '{' && params.charAt(0) !== '[') {
                params = '\"' + params;
            }
            if (params.charAt(params.length - 1) !== '}' && params.charAt(params.length - 1) !== ']') {
                params = params + '\"';
            }
            params = '[' + params + ']';
            attributes = parseJSON(params);
        }
        return attributes;
    }
}
